import { render } from "./SoftBadge.vue?vue&type=template&id=2b6f42ad&scoped=true"
import script from "./SoftBadge.vue?vue&type=script&lang=js"
export * from "./SoftBadge.vue?vue&type=script&lang=js"

import "./SoftBadge.vue?vue&type=style&index=0&id=2b6f42ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6f42ad"]])

export default __exports__